import styled from "styled-components";

export const SearchSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 32px;
`;

export const SearchTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 400;
  color: var(--color-purple);
  margin: 0 0 16px 0;
  text-align: center;
  font-family: var(--font-display);
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 0;
  width: 100%;
  max-width: 480px;

  .field-holder {
    margin-bottom: 0;
    flex: 1;
  }
`;

export const ListWrapper = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
`;

export const ListItem = styled.div`
  border: 1px solid rgba(130, 136, 148, 0.16);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 12px;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #f8f8f8;
  }

  .product-name {
    font-weight: 600;
    color: var(--color-purple);
    margin-bottom: 4px;
  }

  .synonyms-preview {
    font-size: 13px;
    color: #666;
  }
`;

export const EmptyState = styled.p`
  color: #666;
  padding: 24px 0;
`;
